export default __webpack_public_path__ + "static/media/bg-application-mobile.859a39c5.webp";